import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { salesCreditViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesCN from "../../../components/sales-section/sales-credit-note/create-edit-view-sales-CN";
const SalesCreditView = () => {
  const { id } = useParams();
  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(salesCreditViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="View Sales Credit Note">
          <CreateEditViewSalesCN
            payto={orderDetail?.orderData?.sct_pay_to_address}
            shipto={orderDetail?.orderData?.sct_ship_to_address}
            pageType="credit note"
            page="view"
            type={"return"}
            disabled={true}
            data={orderDetail}
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
            isNotViewOnly={false}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default SalesCreditView;
